/** Resolve caregiver coordinates for marketplace map pins. */

export function resolveCaregiverMapPoint(caregiver, customerCoords, index = 0, total = 1) {
  const mapLat = Number(caregiver?.mapLatitude ?? caregiver?.latitude);
  const mapLng = Number(caregiver?.mapLongitude ?? caregiver?.longitude);
  if (Number.isFinite(mapLat) && Number.isFinite(mapLng)) {
    return { lat: mapLat, lng: mapLng, approximate: false };
  }

  const cLat = Number(customerCoords?.latitude);
  const cLng = Number(customerCoords?.longitude);
  if (!Number.isFinite(cLat) || !Number.isFinite(cLng)) return null;

  const distKm = Number.isFinite(Number(caregiver?.distanceKm))
    ? Math.max(0.4, Number(caregiver.distanceKm))
    : 1.5 + (index % 4) * 0.5;
  const angle = ((index + 1) / Math.max(total, 1)) * Math.PI * 2;
  const cosLat = Math.cos((cLat * Math.PI) / 180) || 1;
  const latOffset = (distKm / 111) * Math.cos(angle);
  const lngOffset = (distKm / (111 * cosLat)) * Math.sin(angle);

  return {
    lat: cLat + latOffset,
    lng: cLng + lngOffset,
    approximate: true,
  };
}

export function buildCaregiverMapMarkers(caregivers = [], customerCoords = {}) {
  const list = Array.isArray(caregivers) ? caregivers : [];
  const total = list.length;

  return list
    .map((caregiver, index) => {
      const point = resolveCaregiverMapPoint(caregiver, customerCoords, index, total);
      if (!point) return null;
      return {
        caregiver,
        id: String(caregiver.id),
        lat: point.lat,
        lng: point.lng,
        approximate: point.approximate,
      };
    })
    .filter(Boolean);
}
